export const phoneMask = '(000)  000  0000'

export const zipCodeMask = '0{5}'

export const sixDigitsZipCodeMask = 'A{6}'

export const membershipMask = '000  000  000000000  0'
